import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {BaseChartDirective, Color, Label} from 'ng2-charts';
import {ChartDataSets, ChartType} from 'chart.js';

@Component({
  selector: 'app-exg-chart',
  templateUrl: './exg-chart.component.html',
  styles: [`
    .chart-container {
      position: relative;
      width: 600px;
      height: 400px;
    }
  `]
})
export class ExgChartComponent extends ExcTranslation implements OnInit {

  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;

  lineChartData: ChartDataSets[] = [
    {
      data: [54,140,121,80,187,631,488,437,351,215,176,161,224,230,538,107,170,238,510,1003,540,607,468,292,865,582,573,262,263,939,772,562,356,408,275,229,302,308,979,493,427,1383,989,934,556,468,274,319,256,972,667,271,222,341,401,498,373,258,182,224,144,316,366,296,224,1098,2106,1233,721,430,348,389,340,735,811,455,419,634,678,593,645,436,456,585,521,345,510,334,420,761,847,1119,1001,752,573,399,376,440,409,385,430,1095,988,831,673,544,417,250,0],
      label: 'In'
    },
    {
      data: [10,139,239,82,146,238,280,473,282,299,352,494,164,95,305,161,173,145,376,336,539,587,525,853,432,243,468,750,440,462,616,438,295,472,311,155,951,297,582,319,403,456,1351,688,911,569,913,575,514,637,554,541,631,657,459,484,430,343,220,210,150,241,338,311,318,461,1123,879,735,781,633,538,303,479,1087,452,603,463,693,574,739,519,480,468,289,541,686,438,455,390,381,492,755,883,635,573,674,507,413,268,334,436,493,643,1461,1313,1040,419,0],
      label: 'Out'
    },
  ];

  lineChartLabels: Label[] = ['2016-01','2016-02','2016-03','2016-04','2016-05','2016-06','2016-07','2016-08','2016-09','2016-10','2016-11','2016-12','2017-01','2017-02','2017-03','2017-04','2017-05','2017-06','2017-07','2017-08','2017-09','2017-10','2017-11','2017-12','2018-01','2018-02','2018-03','2018-04','2018-05','2018-06','2018-07','2018-08','2018-09','2018-10','2018-11','2018-12','2019-01','2019-02','2019-03','2019-04','2019-05','2019-06','2019-07','2019-08','2019-09','2019-10','2019-11','2019-12','2020-01','2020-02','2020-03','2020-04','2020-05','2020-06','2020-07','2020-08','2020-09','2020-10','2020-11','2020-12','2021-01','2021-02','2021-03','2021-04','2021-05','2021-06','2021-07','2021-08','2021-09','2021-10','2021-11','2021-12','2022-01','2022-02','2022-03','2022-04','2022-05','2022-06','2022-07','2022-08','2022-09','2022-10','2022-11','2022-12','2023-01','2023-02','2023-03','2023-04','2023-05','2023-06','2023-07','2023-08','2023-09','2023-10','2023-11','2023-12','2024-01','2024-02','2024-03','2024-04','2024-05','2024-06','2024-07','2024-08','2024-09','2024-10','2024-11','2024-12','2025-01'];
  lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false
  };

  lineChartColors: Color[] = [
    {
      borderColor: 'black',
      backgroundColor: 'rgba(255,255,0,0.28)',
    },
  ];

  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType: ChartType = 'line';


  constructor() {
    super();
    window.onresize = () => {
      this.lineChartOptions = {...this.lineChartOptions};
    };
  }

  ngOnInit(): void {
  }

}
